export const SUITE = [
  {
    id: "iq",
    name: "Pravadh IQ",
    tag: "Code + Data DevOps",
    blurb: "The operating system for Salesforce change. Deploy, migrate, and audit on a SHA-256 chain.",
    href: "https://pravadhiq.pravadhlabs.com",
  },
  {
    id: "pm",
    name: "Pravadh PM",
    tag: "Delivery OS",
    blurb: "Ship work. Brand it yours. Run it anywhere — Jira-grade issues, your brand, your servers.",
    href: "https://pravadhpm.pravadhlabs.com",
  },
  {
    id: "gx",
    name: "Pravadh GovernX",
    tag: "Governance",
    blurb: "Extract data. Govern every limit. White-label it, run your own LLM, deploy to your servers.",
    href: "/",
    current: true,
  },
];

export const TRUST_BADGES = [
  "AES-256-GCM Encrypted",
  "SOC-2 Ready",
  "SHA-256 Audit Chain",
];

export const LABS_URL = "https://pravadhlabs.com";
export const LABS_LABEL = "Pravadh Labs";
